
import BoardMarquee from "@/components/BoardMarquee.vue"
import CompleteTextCalltype from "@/components/complete/CompleteTextCalltype.vue"
import CompleteImgCalltype from "@/components/complete/CompleteImgCalltype.vue"
import CompleteTextWait from "@/components/complete/CompleteTextWait.vue"
import ButtonBig from "@/components/ButtonBig.vue"
import ButtonIcon from "@/components/ButtonIcon.vue"
import CompleteDialogFailConnect from "@/components/complete/CompleteDialogFailConnect.vue"

import { defineComponent, computed } from "vue"
import { useStore } from "vuex"
import { useRoute } from "vue-router"
import HeaderLogo from "@/components/HeaderLogo.vue"

export default defineComponent({
  components: {
    BoardMarquee,
    CompleteTextCalltype,
    CompleteImgCalltype,
    CompleteTextWait,
    ButtonBig,
    ButtonIcon,
    CompleteDialogFailConnect,
    HeaderLogo,
  },
  setup() {
    const { state, commit } = useStore()
    const { query } = useRoute()
    const { carnumber } = query

    const calltype = window.location.pathname.slice(1)

    const isDialogOpen = computed(() => state.complete.isDialogOpen)
    if (carnumber !== null && carnumber !== undefined) {
      commit("complete/SET_CAR", carnumber.toString().split("?")[0])
    }
    commit("complete/SET_CALLTYPE", calltype)
    return {
      isDialogOpen,
    }
  },
})
